import MuiLinkIcon from '@mui/icons-material/LinkRounded'
import { styled } from '@mui/system'

export const LinkIcon = styled(MuiLinkIcon)({
  transform: 'rotate(135deg)',
  width: '16px',
  height: '16px',
})
